import Checklist753Assessment from '../components/who/Checklist753Assessment';
import HHSAFAssessment from '../components/who/HHSAFAssessment';

const CHECKLIST_753_ID = 'CHECKLIST_753_WHO_HAND_HYGIENE';
const HHSAF_ID = 'WHO_HHSAF_2010';

/**
 * Map audit assessment instance to the correct WHO evaluation UI.
 * Previously all instruments opened Checklist753, causing answer key mismatch on display.
 */
export function resolveAuditInstrumentComponent(instrumentId) {
  if (instrumentId === CHECKLIST_753_ID) return Checklist753Assessment;
  if (instrumentId === HHSAF_ID) return HHSAFAssessment;
  return null;
}

export function isAuditInstrumentSupported(instrumentId) {
  return resolveAuditInstrumentComponent(instrumentId) != null;
}

export { CHECKLIST_753_ID, HHSAF_ID };
